// extracted by mini-css-extract-plugin
export default {"wrapperLoadingInput":"InputUserInfo_wrapperLoadingInput__-vS+g"};